/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  ApproveAchMasterRecipientRequestDto,
  BaseResponseAchServiceDto,
  DeleteAchMasterRecipientRequestDto,
  GetMasterRecipientsRequestDto,
  RejectAchMasterRecipientRequestDto,
  SaveMasterRecipientRequestDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AchMasterRecipientClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags AchMasterRecipient
   * @name AchMasterRecipientGetMasterRecipients
   * @summary Gets master recipients matching the specified criteria.
   * @request POST:/AchMasterRecipient/GetMasterRecipients
   */
  achMasterRecipientGetMasterRecipients = (
    data: GetMasterRecipientsRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseResponseAchServiceDto, any>({
      path: `/AchMasterRecipient/GetMasterRecipients`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AchMasterRecipient
   * @name AchMasterRecipientSaveMasterRecipient
   * @summary Saves a master recipient.
   * @request POST:/AchMasterRecipient/SaveMasterRecipient
   */
  achMasterRecipientSaveMasterRecipient = (
    data: SaveMasterRecipientRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseResponseAchServiceDto, any>({
      path: `/AchMasterRecipient/SaveMasterRecipient`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AchMasterRecipient
   * @name AchMasterRecipientApproveMasterRecipients
   * @summary Approves master recipients.
   * @request POST:/achMasterRecipient/approve
   */
  achMasterRecipientApproveMasterRecipients = (
    data: ApproveAchMasterRecipientRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseResponseAchServiceDto, any>({
      path: `/achMasterRecipient/approve`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AchMasterRecipient
   * @name AchMasterRecipientRejectMasterRecipients
   * @summary Rejects master recipients.
   * @request POST:/achMasterRecipient/reject
   */
  achMasterRecipientRejectMasterRecipients = (
    data: RejectAchMasterRecipientRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseResponseAchServiceDto, any>({
      path: `/achMasterRecipient/reject`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AchMasterRecipient
   * @name AchMasterRecipientDeleteMasterRecipients
   * @summary Deletes master recipients.
   * @request POST:/achMasterRecipient/delete
   */
  achMasterRecipientDeleteMasterRecipients = (
    data: DeleteAchMasterRecipientRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseResponseAchServiceDto, any>({
      path: `/achMasterRecipient/delete`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AchMasterRecipient
   * @name AchMasterRecipientGetAudits
   * @summary Gets audits for a specific master recipient.
   * @request GET:/achMasterRecipient/audits/{achMasterRecipientId}
   */
  achMasterRecipientGetAudits = (achMasterRecipientId: number, params: RequestParams = {}) =>
    this.http.request<BaseResponseAchServiceDto, any>({
      path: `/achMasterRecipient/audits/${achMasterRecipientId}`,
      method: "GET",
      format: "json",
      ...params,
    });
}
